import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get'
import camelCase from 'lodash/camelCase'
import classnames from 'classnames';
import Markdown from '../components/markdown';
import { stringSubstitution } from '../components/contentful-views/util';
import { getSectionsArray, registerWidget } from '../components/contentful-views/sections';
import { 
  stringSubstitutionsPropType, 
  customWidgetsPropType 
} from '../components/common-prop-types';

import List from '../components/list';

/**
 * ListWidget mapping for Contentful List content types.
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/list/fields
 */
const ListWidget = ({
  customWidgets, stringSubstitutions, model, id,
}) => {
  const className = id; // legacy, id was being passed as class name.
  const displayOption = get(model, 'fields.displayOption');
  const listItems = get(model, 'fields.listItems');
  const text = get(model, 'fields.text');
  const title = get(model, 'fields.title');

  const titleText = stringSubstitution(title, stringSubstitutions);
  const subTitle = text ? (
    <Markdown 
      className='subTitle paragraph' 
      source={stringSubstitution(text, stringSubstitutions)}
    />
  ) : null;

  const children = getSectionsArray(listItems, customWidgets);

  return (
    <List
      className={classnames(className, camelCase(displayOption))}
      displayOption={displayOption}
      subTitle={subTitle}
      title={titleText}>
      {children}
    </List>
  );
};

ListWidget.propTypes = {
  customWidgets: customWidgetsPropType,
  stringSubstitutions: stringSubstitutionsPropType,
  id: PropTypes.string,
  model: PropTypes.shape({}),
};

ListWidget.defaultProps = {
  customWidgets: {},
  stringSubstitutions: {},
  id: null,
  model: {},
};

registerWidget('list', ListWidget);

export default ListWidget;
